import {
    makeStyles,
} from 'app/tss'

const useStyles = makeStyles()((theme) => {
    return {
        paragraph: {
            marginTop: theme.spacing(0.8),
        },
    }
})

export default useStyles
